import AHDate from "_shared/dates/date";
import EntityMember from "_shared/entity-members/entity-member";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import FeeScheduleTag from "_shared/fee-schedules/tags/fee-schedule-tag";
import Guid from "_shared/guids/guid";
import { FeeScheduleCategoryMaskedCurrency } from "work/_shared/masked-fields";
import FeeScheduleTemplateSchema, {
  FeeScheduleTemplateJSON,
  FeeScheduleTemplateParams,
} from "work/fee-schedule-templates/_schemas/fee-schedule-template-schema";

export default class FeeScheduleTemplate {
  public static create(params: FeeScheduleTemplateParams): FeeScheduleTemplate {
    const parsed = FeeScheduleTemplateSchema.validate(params);
    return new FeeScheduleTemplate({ ...parsed, ...params });
  }

  public static fromJSON(json: FeeScheduleTemplateJSON): FeeScheduleTemplate {
    const templateParams = FeeScheduleTemplateSchema.deserialize(json);
    return new FeeScheduleTemplate(templateParams);
  }

  public static fromJSONArray(jsonArray: FeeScheduleTemplateJSON[]): FeeScheduleTemplate[] {
    return jsonArray.map((json) => FeeScheduleTemplate.fromJSON(json));
  }

  public readonly id?: Guid;
  public readonly creator?: EntityMember;
  public readonly created?: AHDate;
  public readonly name: string;
  public readonly tags: FeeScheduleTag[] = [];
  public readonly categories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[] = [];
  public readonly archived?: AHDate;

  constructor(params: FeeScheduleTemplateParams) {
    this.id = params.id;
    this.created = params.created;
    this.creator = params.creator ? EntityMember.create(params.creator) : undefined;
    this.name = params.name;
    this.tags = params.tags ?? [];
    this.categories =
      params.categories?.map((category) =>
        category.currencyIsMasked
          ? FeeScheduleCategoryMaskedCurrency.create(category)
          : FeeScheduleCategory.create(category)
      ) ?? [];
    this.archived = params.archived;
  }

  public toJSON(): FeeScheduleTemplateJSON {
    return FeeScheduleTemplateSchema.serialize(this);
  }

  public isUsing(categories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[]): boolean {
    return categories.some((category) => {
      return this.categories.some((thisCategory) => category.id.isEqualTo(thisCategory.id));
    });
  }
}
